export const getWeekDeclension = (num: number): string => {
    const absNum = Math.abs(num);
    if (absNum % 10 === 1 && absNum % 100 !== 11) {
        return "тиждень";
    }
    if (
        [2, 3, 4].includes(absNum % 10) &&
        ![12, 13, 14].includes(absNum % 100)
    ) {
        return "тижні";
    }
    return "тижнів";
};
